module.exports = __webpack_public_path__ + "images/39d1483e335e87f0481b656ec1057411.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/icons/home.svg
// module id = 1035
// module chunks = 0